import { formatCount, formatPercent } from './callTypesModel';

/** Список значений выхода с долей. Полоса считается от `max`, доля в подписи — от `denominator`. */
const CategoryList = ({ items, selectedCode, onSelect, max, denominator, denominatorLabel }) => (
  <div className="mt-4 max-h-[460px] divide-y overflow-y-auto pr-1">
    {items.map((item) => {
      const isSelected = selectedCode === item.code;

      return (
        <button
          key={item.code}
          type="button"
          data-ev="call_paths.category.select"
          aria-pressed={isSelected}
          onClick={() => onSelect(item.code)}
          className={`w-full rounded-lg px-2 py-2.5 text-left text-sm transition-colors ${
            isSelected ? 'bg-blue-50 text-blue-700 dark:bg-blue-950/30 dark:text-blue-300' : 'hover:bg-muted/50'
          }`}
        >
          <span className="flex items-start justify-between gap-3">
            <span className="min-w-0 font-medium">{item.label}</span>
            <span className="shrink-0 font-semibold tabular-nums">{formatCount(item.calls)}</span>
          </span>
          <span className="mt-1.5 block h-1.5 overflow-hidden rounded-full bg-muted">
            <span
              className={`block h-full rounded-full ${isSelected ? 'bg-blue-500' : 'bg-blue-400'}`}
              style={{ width: `${Math.min(100, (item.calls / Math.max(1, max || denominator || 1)) * 100)}%` }}
            />
          </span>
          {denominator > 0 && (
            <span className="mt-1 block text-xs text-muted-foreground">
              {formatPercent(item.calls, denominator)} {denominatorLabel}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default CategoryList;
